'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:UserCtrl
 * @description
 * # UserCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('UserCtrl', ['$scope', 'User', 'Pagination', function ($scope, User, Pagination) {
    $scope.users = {
      list: [],
      pager: {}
    };
  
    $scope.role_list = [
      'Todos',
      'Administrador',
      'Operador' ,
      'Finanzas',
    ];
    $scope.search = {
      'search': '',
      'by_column': '',
      'by_role': [],
      'filters': {
        'name': 'fa-sort-asc',
        'email': 'fa-sort'
      }
    } 

    $scope.addRoleFilter = function() {
      if(!$scope.search.by_role.includes($scope.role_selected)) {
        $scope.search.by_role.push($scope.role_selected);
        $scope.getPage(1);
      }
    };

    $scope.removeRoleFilter = function(index) {
      $scope.search.by_role.splice(index, 1);
      if($scope.search.by_role.length === 0) {
        $scope.role_selected = $scope.role_list[0];
      }
      $scope.getPage(1);
    };

    $scope.getPage = function(page) {
      if($scope.search.by_role.includes('Todos')) {
        $scope.search.by_role  = [];
      }
      var params = {
        params: {
          page: page,
          per_page: 10,
          by_role: JSON.stringify($scope.search.by_role),
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      }
      User.index(params).then(function(response) {
        $scope.users.list = response.data.users;
        $scope.users.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      },function(error) {
        User.error(error);
      });
    };

    $scope.pager = {};
    $scope.getPage(1);

    $scope.clearSearch = function() {
      $scope.search.by_role  = [];
      $scope.role_selected = $scope.role_list[0];
      $scope.search = {
        'search': '',
        'by_column': '',
        'by_role': $scope.search.by_role,
        'filters': {
          'name': 'fa-sort-asc',
          'email': 'fa-sort'
        }
      };
      $scope.getPage(1);
    }

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.deleteUser = function(user) {
      var index = $scope.users.list.indexOf(user);
      User.delete(user.id).then(function() {
        $scope.users.list.splice(index, 1);
      }, function(error) {
        User.error(error);
      });
    };
  }]);
